import { QuizResult } from "@/models/quiz.model";
import { QuizRest } from "@/services/rest/quiz.rest";
import { BehaviorSubject, Observable, Subject, take } from "rxjs";

export class QuizService {
  private classroomId: string | undefined;

  constructor(private _quiz = new QuizRest()) {
    this.classroomId = localStorage.getItem("classId") ?? undefined;
  }

  private quiz$: Subject<any> = new Subject<any>();
  quiz: Observable<any> = this.quiz$.asObservable();
  private result$: Subject<QuizResult> = new Subject<QuizResult>();
  result: Observable<QuizResult> = this.result$.asObservable();

  hasEnded$: BehaviorSubject<any> = new BehaviorSubject<any>(false);

  getQuizByLearningObjectId(objectiveId: string): void {
    this._quiz
      .getQuizByLearningObject(objectiveId, { classroomId: this.classroomId })
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.quiz$.next(response);
        },
      });
  }

  getQuizResult(objectiveId: string): void {
    this._quiz
      .getQuizResult(objectiveId, { classroomId: this.classroomId })
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.result$.next(response);
        },
        error: (error) => {
          this.result$.next(error);
        },
      });
  }
}
